import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';

import { Form } from './../../models/forms/forms.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { ContainedFormFields } from './../../models/editors/contained-form-fields.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';


@Component({
  selector: 'swb-form-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class FormDetailComponent extends FormDetailBase<Form> implements OnInit {

  public url = 'forms';
  protected _redirect = './forms';

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název',
        validators: [Validators.required]
      }),
      new Textbox({
        key: 'email',
        label: 'Email, kam se odešle',
        validators: [Validators.required, Validators.email]
      }),
      new Textbox({
        key: 'heading',
        label: 'Titulek formuláře na webu',
        isMultilang: true
      }),
      new ContainedFormFields({
        key: 'formfields',
        label: 'Formulářová pole',
        validators: [],
        containedMultilang: true
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }
    this._getEntity();
  }

}
